import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	StarterDashboardV2RootPageDataQuery,
	StarterDashboardV2RootPageDataQueryVariables,
} from '../rootPageData.graphql';
import { StarterDashboardV2RootPageData } from '../rootPageData.graphql';

export async function getStarterRootPageData(
	fetch: UtilityContext['gql']['fetch'],
	{
		slug,
		completedSince,
		locale,
		countryCode,
		emailEnabled,
		includePetitionUpdatesInfo = false,
	}: {
		slug: string;
		completedSince: string;
		locale: string;
		countryCode: string;
		emailEnabled: boolean;
		includePetitionUpdatesInfo?: boolean;
	},
) {
	return fetch<StarterDashboardV2RootPageDataQuery, StarterDashboardV2RootPageDataQueryVariables>({
		query: StarterDashboardV2RootPageData,
		variables: { slug, completedSince, locale, countryCode, emailEnabled, includePetitionUpdatesInfo },
		rejectOnError: true,
	});
}
